import Vue from "vue"
export default {
  // 问卷详情
  setQuestionnaireData (state, res) {
    state.questionnaireData = res
  },
  // 问卷题目列表
  setQuestionnaire (state, res) {
    state.questionnaireList = res
  },
  setPager (state, res) {
    state.pager = res
  },
  // 设置当前题目已答
  setQuestionAnswered (state, res) {
    console.log(res.index)
    state.questionnaireList[res.index].v_answered = res.v_answered
  },
  // 设置用户答的当前题型答案
  setQusstionUserAnswer (state, res) {
    state.questionnaireList[res.index].v_answer = res.v_answer
  },
  // 设置底色配置项
  setColorOption(state, option){
    console.log("option: ", option)
    Vue.set(state, "colorOption", option)
    console.log(22, state)
  },
  // 设置当前是否查看详情
  setIsViewDetails(state, data){
    state.isViewDetails = data;
  },
}
